import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SplatDeformIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M15.99 12.13C16.56 10.36 17.06 8.82996 16.11 7.87996C15.16 6.92996 13.63 7.42996 11.86 7.99996C9.05 8.90996 5.86 9.94996 3.62 6.57996C3.39 6.22996 2.92 6.13996 2.58 6.36996C2.24 6.59996 2.14 7.06996 2.37 7.40996C5.25 11.73 9.51 10.34 12.32 9.42996C13.4 9.07996 14.74 8.63996 15.04 8.93996C15.34 9.23996 14.9 10.58 14.55 11.66C13.63 14.48 12.25 18.74 16.57 21.61C16.91 21.84 17.38 21.75 17.61 21.4C17.84 21.06 17.75 20.59 17.4 20.36C14.03 18.11 15.06 14.93 15.98 12.12L15.99 12.13Z"
        fill={color}
      />
      <path
        d="M21.8 1.59997H18.47C18.15 1.59997 17.99 1.98997 18.21 2.21997L19.55 3.55997L17.55 5.55997C17.31 5.79997 17.31 6.19997 17.55 6.43997C17.79 6.67997 18.19 6.67997 18.43 6.43997L20.43 4.43997L21.77 5.77997C22 6.00997 22.39 5.84997 22.39 5.51997V2.18997C22.39 1.85997 22.12 1.58997 21.79 1.58997L21.8 1.59997Z"
        fill={color}
      />
      <path
        d="M4.38 19H3.37C3.02758 19 2.75 19.2776 2.75 19.62V20.63C2.75 20.9724 3.02758 21.25 3.37 21.25H4.38C4.72242 21.25 5 20.9724 5 20.63V19.62C5 19.2776 4.72242 19 4.38 19Z"
        fill={color}
      />
      <path
        d="M9.63 18.75H8.62C8.27758 18.75 8 19.0276 8 19.37V20.38C8 20.7224 8.27758 21 8.62 21H9.63C9.97242 21 10.25 20.7224 10.25 20.38V19.37C10.25 19.0276 9.97242 18.75 9.63 18.75Z"
        fill={color}
      />
      <path
        d="M10.63 12.75H9.62C9.27758 12.75 9 13.0276 9 13.37V14.38C9 14.7224 9.27758 15 9.62 15H10.63C10.9724 15 11.25 14.7224 11.25 14.38V13.37C11.25 13.0276 10.9724 12.75 10.63 12.75Z"
        fill={color}
      />
      <path
        d="M4.63 13.75H3.62C3.27758 13.75 3 14.0276 3 14.37V15.38C3 15.7224 3.27758 16 3.62 16H4.63C4.97242 16 5.25 15.7224 5.25 15.38V14.37C5.25 14.0276 4.97242 13.75 4.63 13.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SplatDeformIcon.displayName = 'SplatDeformIcon';
